import { ConfigProvider } from "antd";
import { Navigate, Route, Routes } from "react-router";
import "./App.css";
import AuthLayout from "./layout/AuthLayout";
import UnAuthLayout from "./layout/UnAuthLayout";
import LoginPage from "./pages/SharedPage/LoginPage/LoginPage";
import colors from "./style.module.scss";
import { Amplify } from "aws-amplify";
import ForgotPasswordPage from "./pages/SharedPage/ForgotPasswordPage/ForgotPasswordPage";
import APP_CONFIG from "./configs/environment";
import ForgotPasswordSubmitPage from "./pages/SharedPage/ForgotPasswordSubmitPage/ForgotPasswordSubmitPage";
import Archived from "./pages/JobModulePages/ArchivedTabPage/ArchivedTabPage";
import InProgress from "./pages/JobModulePages/InProgressTabPage/InProgressTabPage";
import { Provider } from "react-redux";
import store from "./redux/store";
import QCDetailPage from "./pages/JobModulePages/QCDetailPage/QCDetailPage";
import AuthPackLayout from "./layout/AuthPackLayout";
import NewCompleted from "./pages/JobModulePages/CompletedTab/CompletedTab";
import OrganizationsPage from "./pages/SettingModulePages/OrganizationsPage/OrganizationsPage";
import SettingsAuthTab from "./components/SharedComponent/nav/SettingsAuthTab";
import UsersPage from "./pages/SettingModulePages/UsersPage/UsersPage";
import SettingsAuthpackLayout from "./layout/SettingsAuthpackLayout";
import AdminDetailPage from "./pages/SettingModulePages/AdminDetailPage/OrganizationDetailPage";
import AccessDenied from "./components/Template/AccessDenied/AccessDenied";
import NotFound from "./components/Template/NotFoundPage/NotFound";

Amplify.configure(APP_CONFIG.amplify_config);

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: { colorPrimary: colors.colorPrimary },
        }}>
        <Routes>
          <Route
            path=""
            element={<UnAuthLayout />}>
            <Route
              path=""
              element={<LoginPage />}
            />
            <Route
              path="forgot-password"
              element={<ForgotPasswordPage />}
            />
            <Route
              path="forgot-password-submit"
              element={<ForgotPasswordSubmitPage />}
            />
            <Route
              path="*"
              element={<NotFound returnPath="" />}
            />
          </Route>
          <Route
            path="auth"
            element={<AuthLayout />}>
            <Route
              path=""
              element={<AuthPackLayout />}>
              <Route
                path=""
                element={<Navigate to="/auth/inprogress" />}
              />
              <Route
                path="inprogress"
                element={<InProgress />}
              />
              <Route
                path="completed"
                element={<NewCompleted />}
              />
              <Route
                path="archived"
                element={<Archived />}
              />
            </Route>

            <Route
              path=""
              element={<SettingsAuthpackLayout />}>
              <Route
                path="organizations"
                element={<OrganizationsPage />}
              />

              <Route
                path="users"
                element={<UsersPage />}
              />
            </Route>
            <Route
              path="access-denied"
              element={<AccessDenied />}
            />
            <Route
              path="pack/:id"
              element={<QCDetailPage />}
            />
            <Route
              path="organization/:id"
              element={<AdminDetailPage />}
            />
            <Route
              path="*"
              element={<NotFound returnPath="/auth/inprogress" />}
            />
          </Route>
        </Routes>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
